import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {dwhBanReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {futurePaymentScheduledDate, formatAmount, isWithinInvoicePeriod} from '../utils/banTypeClassifier';
import {useDebtPaymentSelectAmount} from '../hooks/useDebtPaymentSelectAmount';
import useEnterKeyPress from '../hooks/useEnterKeyPress';
import {stepEnum, popupEnum} from '../Constants/debtPaymentEnum';
import WarningMessage from '../SharedComponents/WarningMessage';
import {isMobile} from 'react-device-detect';

const SelectAmount = ({selectedBanData, yDaysCount, yDaysCountEnergy, bitPaymentOption}) => {
  const {actions} = useDebtPaymentSelectAmount();
  const loginData = useSelector((state) => state.authentication.loginData);
  const formattedDebtAmount = formatAmount(selectedBanData.amount);

  const parsedDebtAmount = parseFloat(selectedBanData.amount) || 0;
  const parsedTotalDueAmount = parseFloat(selectedBanData.totalDueAmount) || 0;
  const parsedArBalance = parseFloat(selectedBanData?.arBalance) || 0;

  const futurePaymentAmount = () => {
    const yCount = selectedBanData.isEnergy ? yDaysCountEnergy : yDaysCount;

    if (isWithinInvoicePeriod(selectedBanData.prdCvrgEndDate, yCount, selectedBanData.billDueDate)) {
      if (parsedArBalance !== parsedTotalDueAmount) {
        if (parsedArBalance > 0) {
          return parsedArBalance;
        }
        if (parsedTotalDueAmount > 0) {
          return parsedTotalDueAmount;
        }
      } else {
        if (parsedArBalance > 0 && parsedTotalDueAmount > 0) {
          return parsedTotalDueAmount;
        }
        return 0;
      }
    }
    return 0;
  };

  const [isFutureDebtChecked, setIsFutureDebtChecked] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState(() =>
    formatAmount(selectedBanData.hasDebt ? selectedBanData.amount : futurePaymentAmount()),
  );
  const parsedPaymentAmount = !paymentAmount ? null : parseFloat(paymentAmount);

  useEffect(() => {
    dwhBanReport({
      banData: selectedBanData,
      loginData,
      paymentAmount,
      actionType: DwhActionType.DebtSumPage,
      messageText: DWHMessageText.DebtSumPageDisplayed,
      status: DWHStatus.Ongoing,
      yDaysCount,
      yDaysCountEnergy,
    });
  }, []);

  const showWarningMessage =
    selectedBanData.hasDebt &&
    parsedPaymentAmount != null &&
    !isNaN(parsedPaymentAmount) &&
    parsedPaymentAmount > 0 &&
    parsedPaymentAmount < parsedDebtAmount;

  const getMaxPaymentAmount = () => {
    const debt = selectedBanData.hasDebt ? parsedDebtAmount : 0;
    if (futurePaymentAmount() > 0) {
      return debt + futurePaymentAmount();
    } else return debt;
  };

  const handleCheckBox = (checked) => {
    setIsFutureDebtChecked(checked);
    if (checked) {
      setPaymentAmount(formatAmount(futurePaymentAmount() + parsedDebtAmount));
    } else {
      setPaymentAmount(formatAmount(parsedDebtAmount));
    }
  };

  const isValid =
    parsedPaymentAmount != null && !isNaN(parsedPaymentAmount) && parsedPaymentAmount > 0 && parsedPaymentAmount <= getMaxPaymentAmount();

  const advanceToPaymentOption = () => {
    if (isValid) {
      dwhBanReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        actionType: DwhActionType.DebtSumPage,
        messageText: DWHMessageText.DebtSumPageButtonClicked,
        status: DWHStatus.Ongoing,
        yDaysCount,
        yDaysCountEnergy,
      });
      actions.setAmount(parseFloat(paymentAmount));
      if (selectedBanData.isEnergy) {
        actions.handleCurrentStep(stepEnum.CREDITCARD);
      } else {
        if (selectedBanData.hasPaymentMethodIssue) {
          actions.setShowPopup({showPopUp: true, popupType: popupEnum.PAYMENT_METHOD_ISSUE});
        } else {
          if (!bitPaymentOption) {
            actions.handleCurrentStep(stepEnum.CREDITCARD);
          } else {
            actions.handleCurrentStep(stepEnum.SELECTPAYMENTTYPE);
          }
        }
      }
    }
  };

  useEnterKeyPress(advanceToPaymentOption, !isValid);

  const getErrorMessage = () => {
    if (parsedPaymentAmount <= 0) return 'הינך מתבקש להזין סכום לתשלום';
    if (parsedPaymentAmount > getMaxPaymentAmount()) return `לא ניתן לשלם סכום גבוה מ-₪${formatAmount(getMaxPaymentAmount())}`;
    return null;
  };

  const getWarningMessage = () => {
    const debtBalance = parsedDebtAmount - parsedPaymentAmount;
    let message = `<div> תישאר יתרת חוב בסך: <span class="amount red bold">₪${formatAmount(debtBalance)}</span></div>`;
    if (selectedBanData.paused) message += `<div >כדי להפעיל מחדש את החשבון, יש לשלם<br /> את כל החוב `;
    return message;
  };

  return (
    <div className='select-amount-step debtpayment-step'>
      <div className={`select-payment-ban__title bold ${isMobile ? 'm-title ' : 'l-title '}`}>תשלום חשבון {selectedBanData.banNumber}</div>
      {selectedBanData.hasDebt && selectedBanData.amount > 0 && (
        <div className='select-amount-debt-summary background'>
          <span className='select-amount-debt-summary__label bold-600'>חוב מצטבר לחיוב</span>
          <span className='select-amount-debt-summary__amount select-amount-debt-summary__amount--red'>₪{formattedDebtAmount}</span>
        </div>
      )}
      {futurePaymentAmount() > 0 && (
        <>
          <div className='select-amount-debt-summary future background'>
            <span className='select-amount-debt-summary__label'>
              {(() => {
                const d = futurePaymentScheduledDate(selectedBanData);
                if (!d) return null;
                return (
                  <div className='select-amount-debt-summary__label-text'>
                    <div className='bold'>{d.invoicePart}</div>
                    <div className='select-amount-debt-summary__label-text-charge'>
                      {d.chargeText} {d.chargeDateText}
                    </div>
                  </div>
                );
              })()}
            </span>
            <span className='select-amount-debt-summary__amount'>₪{formatAmount(futurePaymentAmount())}</span>
          </div>
          {selectedBanData.hasDebt && (
            <CheckBox
              id={'future-debt-check-box'}
              onCheck={(e) => handleCheckBox(!isFutureDebtChecked)}
              onUncheck={(e) => handleCheckBox(!isFutureDebtChecked)}
              checked={!!isFutureDebtChecked}
              label={'הוספת החשבונית לתשלום'}
              customClassName='square'
            />
          )}
        </>
      )}

      <div className='select-amount-question'>
        <div className={`select-amount-question__text ${isMobile ? 's-title-small ' : 's-title '} bold-600`}>מה הסכום לתשלום?</div>
        <div className='select-amount-input-wrapper'>
          <TextInput
            autoComplete='off'
            placeholder='סכום לתשלום'
            value={paymentAmount}
            type='number'
            error={getErrorMessage()}
            onChange={(e) => setPaymentAmount(e.target.value)}
            disabled={isFutureDebtChecked}
            required={true}
          />
        </div>
        {showWarningMessage && <WarningMessage message={getWarningMessage()} />}
      </div>

      <div className='continue-button'>
        <BtnSubmit text={'המשך'} onclick={() => advanceToPaymentOption()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedBanData: state.debtAndUpdatePayment.selectedBanData,
  yDaysCount: state.debtAndUpdatePayment.paymentStatusDisplayDaysY,
  yDaysCountEnergy: state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY,
  bitPaymentOption: state.debtAndUpdatePayment.bitPaymentOption,
});

export default connect(mapStateToProps)(SelectAmount);
